import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_xoa4wue",     // Service ID
        "template_f3r5yga",    // Template ID
        form.current,
        "fdPzguftIl06UuudP"    // Public Key
      )
      .then(
        () => {
          setStatus("Message envoyé avec succès !");
          form.current.reset();
        },
        (error) => {
          console.error("Erreur EmailJS :", error);
          setStatus("Une erreur est survenue. Réessaie.");
        }
      );
  };

  return (
    <div style={{ maxWidth: "600px", margin: "2rem auto", padding: "1rem" }}>
      <h1>Contact</h1>

      <form ref={form} onSubmit={sendEmail}>
        <div style={{ marginBottom: "1rem" }}>
          <label>Nom :</label>
          <input
            type="text"
            name="user_name"
            required
            style={{ width: "100%", padding: "0.5rem" }}
          />
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <label>Email :</label>
          <input
            type="email"
            name="user_email"
            required
            style={{ width: "100%", padding: "0.5rem" }}
          />
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <label>Message :</label>
          <textarea
            name="message"
            rows="5"
            required
            style={{ width: "100%", padding: "0.5rem" }}
          />
        </div>

        <button type="submit" className="steampunk-button">
          Envoyer
        </button>
      </form>

      {status && <p style={{ marginTop: "1rem" }}>{status}</p>}
    </div>
  );
};

export default Contact;